import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { InvoiceSaleService } from '../../inventory/sales/invoice-sale/invoice-sale.service';
import { AuthenticationService } from '../../authentication/authentication/authentication.service';
import { InputAutocompleteModel } from 'src/app/models/input-autocomplete.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { BillpayService } from 'src/app/services/billpay.service';
import { AccountService } from 'src/app/services/account.service';
import { BankService } from 'src/app/services/bank.service';
import { ExpenseService } from 'src/app/services/expense.service';
import { VendorService } from 'src/app/services/vendor.service';
import { HttpErrorResponse } from '@angular/common/http';
import { CurrencyService } from 'src/app/services/currency.service';
import { getLongDate } from 'src/app/common/util';

declare let $: any;

@Component({
  selector: 'app-billp-uppay',
  templateUrl: './billp-uppay.component.html',
  styleUrls: ['./billp-uppay.component.scss']
})
export class BillpUppayComponent {
  client = new InputAutocompleteModel("", false, false, "", "loading", "", "", null, []);
  clients = [];
  cashiers = [];
  lots = [];
  invoicesLot = [];
  filterClients = [];
  user = null;
  timeout = null;
  clientSelected = null;

  activeTab: string = 'invoices';

  data: any = {
    expenseInvoices: [],
    loans: [],
    providerInvoices: [],
    notes: [],
  };

  // Campos fijos
  documentType: string = '';
  amount: number = 0;
  entryDate: string = '';
  description: string = '';

  cashSelected: number | undefined = undefined;
  documentNumber: string = '';
  isDollar: boolean = false;
  exchangeRate: number = 0.0000;
  correlative: 0;
  calculatedAmount: number = 0;
  amountEditedManually: boolean = false;

  isReceipt: boolean = true;
  advances: any[] = [];
  advanceSelected: any = null;
  filteredAdvances: any[] = [];
  advanceSearch: string = "";

  constructor(
      private toastService: ToastrService,
      private accountService: AccountService,
      private vendorService: VendorService,
      private billPayService: BillpayService,
      private authService: AuthenticationService,
      private bankService: BankService,
      private expenseService: ExpenseService,
      private currencyService: CurrencyService,
    ) {
      this.user = this.authService.getUserPosition();
    }

  ngOnInit(): void {
    this.entryDate = this.getTodayDate();
    this.vendorService.getVendors().subscribe({
      next: (response: ResponseObject) => {
        const clientsData = response.data;
        this.clients = clientsData;
        this.client.filterElements = clientsData;
        this.client.class = "fa-list";
      },
      error: (error) => {
        console.error("Error al comunicarse con el servidor", error);
      }
    }); 
    this.accountService.getCashs().subscribe({
      next: (response: ResponseObject) => {
        this.cashiers = response.data;
        if (this.user) {
          const unique = new Set<number>();
          this.user.forEach((elemento) => {
            unique.add(elemento.cash);
          });
          const filter = Array.from(unique);
          this.cashiers = response.data.filter(cash => filter.includes(cash.id));
          if (this.cashiers.length == 1) {
            this.cashSelected = this.cashiers[0].id;
          }
        }
      },
      error: (error: any) => {
        this.toastService.error("Error al obtener las cajas, por favor recarga la página");
      }
    });   
    this.getLots();
    this.getCorrelative();
    this.getAdvances();
    this.getExchangeRate();
  }

  getLots(){
    this.expenseService.getLotsExpense().subscribe({
      next: (response: ResponseObject) => {
        this.lots = response.data;
        console.log(this.lots)
      },
      error: (error) => {
        console.error("Error al recibir los lotes", error);
      }
    });
  }

  getAdvances() {
    this.bankService.getAdvancesUpPay().subscribe({
      next: (response: ResponseObject) => {
        this.advances = response.data;
        this.filteredAdvances = [...this.advances]; // Inicialmente todos
      },
      error: (error: any) => {
        this.toastService.error("Error al obtener los avances, por favor recarga la página");
      }
    });
  }

  filterAdvances() {
    const search = this.advanceSearch.toLowerCase();
    this.filteredAdvances = this.advances.filter(a =>
      (a.description && a.description.toLowerCase().includes(search)) ||
      (a.rootLocation && a.rootLocation.toLowerCase().includes(search)) ||
      (a.amount && a.amount.toString().includes(search)) ||
      (a.beneficiary && a.beneficiary.toLowerCase().includes(search))
    );
  }

  writeClient() {
      clearTimeout(this.timeout);
      this.client.class = "typing";
      this.timeout = setTimeout(() => {
        this.client.class = "loading";
        this.vendorService.getProvidesByClue(this.client.value).subscribe({
          next: (response: ResponseObject) => {
            this.client.filterElements = response.data;
            if (this.client.filterElements.length == 0) {
              this.client.class = "fa-xmark";
              this.client.required = true;
            } else {
              this.client.class = "fa-filter";
            }
          }, error: (error: any) => {
            this.client.required = true;
            this.client.class = "fa-xmark";
            this.toastService.error("Error al obtener los datos del cliente " + this.client.value);
          }
        })
      }, 500);
    }
  
    selectClient(client: any, status) {
      this.client.value = "";
      this.client.class = "";
      this.client.required = false;
      this.filterClients = this.clients;
      console.log(client);
      this.clientSelected = client;
      this.cashSelected = undefined;
      this.documentNumber = '';
      this.isDollar = false;
      this.exchangeRate = 0.0000;
      if(client != null){
        this.getDataClient(client.id);
      }
      this.getCorrelative();
      this.getExchangeRate();
      $('body').click();
    }

    getDataClient(idClient){
      this.billPayService.getBills(idClient).subscribe({
        next: (response: ResponseObject) => {
          this.data = response.data;
          console.log("Se recibio la data");
          console.log(this.data);
        },
        error: (error) => {
          console.error("Error al comunicarse con el servidor", error);
        }
      });
    }

    formatDate(timestamp: number): string {
      return new Date(timestamp).toLocaleDateString();
    }
  
    async sendSelected() {
      try {
        const selectedProviderInvoices = this.data.providerInvoices
          .filter(invoice => invoice.selected)
          .map(invoice => ({
            invoice: invoice.id,
            amount: invoice.balance,
            type: 0
          }));
    
        const selectedExpenseInvoices = this.data.expenseInvoices
          .filter(invoice => invoice.selected)
          .map(invoice => ({
            invoice: invoice.id,
            amount: invoice.balance,
            type: 1
          }));

        const selectedLoans = this.data.loans
          .filter(loan => loan.selected)
          .map(loan => ({
            invoice: loan.id,
            amount: loan.balance,
            type: 2
          }));

        const selectedNotes = this.data.notes
          .filter(note => note.selected)
          .map(note => ({
            invoice: note.id,
            amount: note.balance,
            type: 4
          }));
    
        const selectedLots = this.lots.filter(lot => lot.selected);
    
        let lotInvoices: any[] = [];
    
        for (const lot of selectedLots) {
          const response: any = await this.expenseService.getLotExpenseById(lot.id).toPromise();
    
          const invoicesFromLot = response.data.map(invoice => ({
            invoice: invoice.id,
            amount: invoice.balance,
            type: invoice.type,
            vendor: invoice.vendor
          }));
    
          lotInvoices = [...lotInvoices, ...invoicesFromLot];
        }
    
        const invoiceList = [
          ...selectedProviderInvoices,
          ...selectedExpenseInvoices,
          ...selectedLoans,
          ...selectedNotes,
          ...lotInvoices
        ];
    
        if (invoiceList.length === 0) {
          this.toastService.error('Debes seleccionar al menos una factura o lote');
          return;
        }
    
        if (this.isReceipt && !this.cashSelected) {
          this.toastService.error('Selecciona una caja');
          return;
        }
        
        if (!this.isReceipt && !this.advanceSelected) {
          this.toastService.error('Selecciona un anticipo');
          return;
        }
    
        if (!this.amount || this.amount <= 0) {
          this.toastService.error('El monto debe ser mayor a 0');
          return;
        }
    
        if (!this.entryDate) {
          this.toastService.error('Selecciona una fecha');
          return;
        }
    
        if (!this.documentNumber) {
          this.toastService.error('Debes ingresar un número de documento');
          return;
        }
    
        if (this.isReceipt) {
          const originalDate = new Date(this.entryDate);
          // Sumarle 6 horas
          originalDate.setHours(originalDate.getHours() + 6);
          // Luego formatearla
          const formattedDate = originalDate.toISOString();
      
          const requestBody: any = {
            currency: this.isDollar ? 1 : 0,
            issuerCash: this.cashSelected.toString(),
            amount: this.amount,
            date: formattedDate,
            docNumber: this.documentNumber,
            description: this.description,
            reason: 11,
            billPayRequest: {
              invoiceList,
              ...(this.clientSelected?.id && { provider: this.clientSelected.id }),
              documentType: "4", // fijo como indicaste
              amount: this.amount,
              date: formattedDate,
              description: this.description
            }
          };
      
          if (this.isDollar) {
            requestBody.exchangeRate = this.exchangeRate;
          }
      
          console.log('Request generado:', requestBody);
      
          this.bankService.orecipe(requestBody).subscribe({
            next: response => {
              this.toastService.success('Pago realizado correctamente');
              this.selectClient(this.clientSelected,1);
              this.clearFixedFields();
              console.log(response);
            },
            error: error => {
              this.toastService.error('Ocurrió un error al generar el pago');
              console.error(error);
            }
          });
        }
        if (!this.isReceipt) {
          const originalDate = new Date(this.entryDate);
          originalDate.setHours(originalDate.getHours() + 6);
          const formattedDate = originalDate.toISOString();
        
          const requestBodyAnticipo = {
            invoiceList: invoiceList,
            amount: this.amount,
            provider: this.clientSelected.id,
            documentType: "7",
            document: `${this.advanceSelected.sourceType}:${this.advanceSelected.docId}`,
            currency: 0,
            exchangeRate: 1,
            description: this.description,
            date: formattedDate
          };

          if (this.isDollar) {
            requestBodyAnticipo.exchangeRate = this.exchangeRate;
            requestBodyAnticipo.currency = 1;
          }
        
          console.log("Request para anticipo:", requestBodyAnticipo);
        
          this.billPayService.setAdvance(requestBodyAnticipo).subscribe({
            next: response => {
              this.toastService.success('Anticipo aplicado correctamente');
              this.selectClient(this.clientSelected, 1);
              this.clearFixedFields();
            },
            error: error => {
              this.toastService.error('Error al aplicar el anticipo');
              console.error(error);
            }
          });
        }
      } catch (error) {
        console.error('Error al recolectar facturas de los lotes:', error);
        this.toastService.error('Ocurrió un error al procesar los lotes');
      }
    }

    clearFixedFields() {
      this.cashSelected = undefined;
      this.documentNumber = '';
      this.amount = 0;
      this.entryDate = '';
      this.description = '';
      this.isDollar = false;
      this.exchangeRate = null;
      this.amountEditedManually = false;
      this.getCorrelative();
      this.getAdvances();
      this.getLots();
    }
    

    getInvoicesLotByIdLot(idLot){
      this.expenseService.getLotExpenseById(idLot).subscribe({
        next: (response: ResponseObject) => {
          this.invoicesLot = response.data;
          console.log(this.data);
        },
        error: (error) => {
          console.error("Error al obtener las facturas del lote", error);
        }
      });
    }

    toggleSelection(item: any) {
      item.selected = !item.selected;
      this.clearSelectionsExcept(this.activeTab);
    }

    clearSelectionsExcept(except: string) {
      if (except !== 'invoices') {
        this.data.expenseInvoices.forEach(invoice => invoice.selected = false);
      }
      if (except !== 'provider') {
        this.data.providerInvoices.forEach(invoice => invoice.selected = false);
      }
      if (except !== 'loans') {
        this.data.loans.forEach(loan => loan.selected = false);
      }
      if (except !== 'notes') {
        this.data.notes.forEach(note => note.selected = false);
      }
      if (except !== 'lots') {
        this.lots.forEach(lot => lot.selected = false);
      }
    }
    
    selectAllActive(): void {
      const shouldSelectAll = !this.areAllSelected();
      this.clearSelectionsExcept(this.activeTab);
    
      switch (this.activeTab) {
        case 'invoices':
          this.data.expenseInvoices.forEach(invoice => invoice.selected = shouldSelectAll);
          break;
        case 'provider':
          this.data.providerInvoices.forEach(invoice => invoice.selected = shouldSelectAll);
          break;
        case 'lots':
          this.lots.forEach(lot => lot.selected = shouldSelectAll);
          break;
        case 'loans':
          this.data.loans.forEach(loan => loan.selected = shouldSelectAll);
          break;
        case 'notes':
          this.data.notes.forEach(note => note.selected = shouldSelectAll);
          break;
      }
    }
    

    areAllSelected(): boolean {
      switch (this.activeTab) {
        case 'invoices':
          return this.data.expenseInvoices.every(i => i.selected);
        case 'provider':
          return this.data.providerInvoices.every(i => i.selected);
        case 'lots':
          return this.lots.every(i => i.selected);
        case 'loans':
          return this.data.loans.every(i => i.selected);
        case 'notes':
          return this.data.notes.every(i => i.selected);
        default:
          return false;
      }
    }
    
    
    getSelectedSummary() {
      let selected = [];
      switch (this.activeTab) {
        case 'invoices':
          selected = this.data.expenseInvoices.filter(i => i.selected);
          break;
        case 'provider':
          selected = this.data.providerInvoices.filter(i => i.selected);
          break;
        case 'lots':
          selected = this.lots.filter(i => i.selected);
          break;
        case 'loans':
          selected = this.data.loans.filter(i => i.selected);
          break;
        case 'notes':
          selected = this.data.notes.filter(i => i.selected);
          break;
      }
    
      const total = selected.reduce((sum, item) => sum + (item.balance || item.totalPaid || 0), 0);
      this.calculatedAmount = parseFloat(total.toFixed(2));

      if (!this.amountEditedManually) {
        this.amount = this.calculatedAmount;
      }
    
      return {
        count: selected.length,
        total: this.calculatedAmount
      };
    }
    
    

    getCorrelative(){
      this.bankService.correlativeCashRecipe().subscribe({
        next: (response: ResponseObject) => {
          this.correlative = response.data;
          this.documentNumber = "REC-" + this.correlative;
          console.log(response);
        },
        error: error => {
          this.toastService.error('Ocurrió un error al generar el correlativo');
          console.error(error);
        }
      });
    }


    onAmountInput() {
      if(this.amount == null || this.amount == 0){
        this.amountEditedManually = false;
      }else{
        this.amountEditedManually = true;
      }
    }

    getCurrencySymbol(currency: number): string {
      return currency === 1 ? '$ ' : 'Q. ';
    }

    getExchangeRate() {
      this.currencyService.getExchangeDollar(getLongDate(this.entryDate)).subscribe({
        next: (response: ResponseObject) => {
          this.exchangeRate = Number(response.data);
        },
        error: (error: HttpErrorResponse) => {
          if(this.isDollar)
            this.toastService.error("Error al obtener la tasa de cambio","Error");
  
        }
      });
    }

    getTodayDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0'); // Los meses comienzan desde 0
      const day = String(today.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }
    
    

}
